import { IPersonaStyles } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontSizes, FontWeights } from '../../themes/styles';
import { mediaMobile } from '../../utils/styles';

export const personaStylesDefault = (theme: IH2OTheme): Partial<IPersonaStyles> => ({
  root: {
    '& + .ms-Icon': { ...mediaMobile({ display: 'none' }) },
  },
  primaryText: {
    fontWeight: FontWeights.semiBold,
    color: theme.semanticColors?.textQuaternary,
  },
  details: { ...mediaMobile({ display: 'none' }) },
  secondaryText: { color: theme.semanticColors?.textSecondary },
});

export const personaStylesMenuButton: Partial<IPersonaStyles> = {
  // for size40
  primaryText: {
    fontWeight: FontWeights.normal,
    fontSize: FontSizes.small,
    lineHeight: 19,
  },
  secondaryText: { fontSize: FontSizes.xsmall, lineHeight: 16, paddingTop: 4 },
  details: {
    paddingLeft: 8,
    paddingRight: 0,
  },
};

export const personaStylesThick: Partial<IPersonaStyles> = {
  primaryText: {
    fontWeight: FontWeights.semiBold,
  },
};
